export const HISTORY = {
  DESCRIPTION: 'Here you can keep track and generate reports of all your Fintel Check records.',
  BACK: 'Back',
};
